// extracted by mini-css-extract-plugin
export default {"icon":"ProfileIcon_icon__ZF2pr","initials":"ProfileIcon_initials__3ww1y"};